<style>
.glow-on-hover {
  border: none;
  outline: none;
  color: #fff;
  background: #111;
  cursor: pointer;
  position: relative;
  z-index: 0;
  border-radius: 5px;
}

.glow-on-hover:before {
  content: "";
  background: linear-gradient(
    45deg,
    #ff0000,
    #ff7300,
    #fffb00,
    #48ff00,
    #00ffd5,
    #002bff,
    #7a00ff,
    #ff00c8,
    #ff0000
  );
  position: absolute;
  top: -2px;
  left: -2px;
  background-size: 400%;
  z-index: -1;
  filter: blur(5px);
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  animation: glowing 20s linear infinite;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  border-radius: 5px;
}

.glow-on-hover:active {
  color: #000;
}

.glow-on-hover:active:after {
  background: transparent;
}

.glow-on-hover:hover:before {
  opacity: 1;
}

.glow-on-hover:after {
  z-index: -1;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: #111;
  left: 0;
  top: 0;
  border-radius: 5px;
}

@keyframes glowing {
  0% {
    background-position: 0 0;
  }

  50% {
    background-position: 400% 0;
  }

  100% {
    background-position: 0 0;
  }
}
</style>
<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper">
        <div class="element-box row col-12" style="background-color: #e0d5ff">
          <div class="col-6" style="min-width: width: 310px;">
            <div >
              <h5 class="form-header">Impresión de Ofertas / Promociones</h5>
              <div class="row">
                <div class="col-12">
                  <TiendaSelectComponent
                    :current="current"
                    :disabled="precios_imprimir.length > 0"
                  />
                </div>
                <div class="col-12">
                  <ProductoSelectComponentV2
                    :current="current"
                    @onChangeProducto="seleccionProducto"
                  >
                  </ProductoSelectComponentV2>
                  <small
                    v-if="current.errors && current.errors.proveedor"
                    class="form-text text-danger"
                    >{{ current.errors.proveedor }}</small
                  >
                </div>
                <hr />
              </div>
              <div class="form-buttons-w">
                <button
                  @click="agregarProducto()"
                  class="btn btn-success btn-md"
                  :disabled="!validacion"
                >
                  <span>Agregar Producto &nbsp; <i class="fas fa-plus"></i></span>
                </button>
                <button class="btn btn-md btn-danger" @click="refreshDataDefault">
                  Limpiar todo &nbsp; <i class="fas fa-sync"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div style="background-color: #f2f2f2; width: 100%">
              <table
                v-if="current.precios_lista.length != 0"
                style="
                  min-width: 308px;
                  width: 100%;
                  height: 314px;
                  margin: 0 auto;
                  background-color: white;
                "
              >
                <tbody>
                  <tr>
                    <td colspan="" class="text-center">
                      <span style="font-size: 30px; font-weight: bold">{{
                        current.producto.nombre
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="" class="text-center">
                      <span
                        style="font-size: 40px; font-weight: bold"
                        v-if="current.precio_1"
                      >
                        {{ current.precio_1.unidad_medida.cantidad_unidades }} X
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="" class="text-center">
                      <select
                        style="font-size: 54px; font-weight: bold; text-align: center"
                        v-model="current.precio_1"
                      >
                        <option
                          v-for="p_current in current.precios_lista"
                          :key="p_current.id"
                          :value="p_current"
                        >
                          Q
                          {{ p_current.precio }}
                        </option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="" class="text-right">
                      <select
                        style="font-size: 18px; text-align: right"
                        v-model="current.precio_2"
                      >
                        <option value="">Sin Precio</option>
                        <option
                          v-for="p_current in current.precios_lista"
                          :key="p_current.id"
                          :value="p_current"
                        >
                          {{ p_current.unidad_medida.cantidad_unidades }} X Q
                          {{ p_current.precio }}
                        </option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="" class="text-center" style="padding: 10px">
                      <input
                        type="text"
                        onkeyup="this.value = this.value.toUpperCase()"
                        v-model="current.texto"
                        style="font-size: 20px; text-align: center"
                        maxlength="45"
                        placeholder="TEXTO ADICIONAL"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colspan="" class="text-center" style="padding: 10px">
                      <span>* Promoción válida hasta agotar existencias</span>
                    </td>
                  </tr>
                </tbody>
                <thead>
                  <tr></tr>
                </thead>
              </table>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="element-box">
            <h5>Productos a Imprimir</h5>

            <div class="row col-12">
              <div class="col-6" v-for="(current_preview, index) in precios_imprimir">
                <div style="background-color: #f2f2f2; width: 104%; padding: 10px 10px">
                  <table
                    v-if="current_preview.precios_lista.length != 0"
                    style="
                      width: 400px;
                      height: 400px;
                      margin: 0 auto;
                      background-color: white;
                    "
                  >
                    <tbody>
                      <tr>
                        <td colspan="" class="text-left">
                          <button
                            class="btn btn btn-danger"
                            @click="quitarItem(current_preview)"
                          >
                            X
                          </button>
                        </td>
                        <td colspan="" class="text-center">
                          <span style="font-size: 30px; font-weight: bold"> &nbsp; </span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="" class="text-center">
                          <span style="font-size: 25px; font-weight: bold">{{
                            current_preview.producto.nombre
                          }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="" class="text-center">
                          <span
                            style="font-size: 30px; font-weight: bold"
                            v-if="current_preview.precio_1"
                          >
                            {{
                              current_preview.precio_1.unidad_medida.cantidad_unidades
                            }}
                            X
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="" class="text-center">
                          <span
                            style="font-size: 44px; font-weight: bold; text-align: center"
                            >Q {{ current_preview.precio_1.precio }}</span
                          >
                        </td>
                      </tr>
                      <tr>
                        <td colspan="" class="text-right">
                          <span
                            style="font-size: 14px; text-align: right"
                            v-if="current_preview.precio_2"
                          >
                            {{
                              current_preview.precio_2.unidad_medida.cantidad_unidades
                            }}
                            X Q {{ current_preview.precio_2.precio }}
                          </span>
                          <span
                            style="font-size: 14px; text-align: right"
                            v-if="!current_preview.precio_2"
                          >
                            &nbsp;
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="" class="text-center" style="padding: 10px ;">
                          <span style="font-size: 15px; text-align: center">{{
                            current_preview.texto
                          }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="" class="text-center" style="padding: 10px ;">
                          <span>* Promoción válida hasta agotar existencias</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="form-buttons-w">
              <button
                @click="Imprimir()"
                class="btn glow-on-hover btn-md"
                :disabled="precios_imprimir.length == 0"
              >
                <span>Generar en PDF &nbsp; <i class="far fa-file-pdf"></i></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import DynamicService from "../../../services/commons/DynamicService";

export default {
  components: {
    ProductoSelectComponentV2,
    TiendaSelectComponent,
  },
  data() {
    return {
      tienda_id: null,
      precio_1: "",
      current: {
        tienda: null,
        producto: {
          sku: null,
        },
        errors: {},
        precios_lista: [],
        precio_1: null,
        precio_2: null,
        texto: null,
      },
      precios_imprimir: [],
      datos: [],
      datos_: [],
    };
  },
  computed: {
    validacion: function () {
      let self = this;
      if (self.current.tienda == null) {
        return false;
      }
      if (self.current.producto.sku == null) {
        return false;
      }
      return true;
    },
  },
  methods: {
    refreshDatos(producto) {
      let self = this;
      DynamicService.getActionList("cat", "productos", "obtener_precio_por_tienda", {
        producto: producto,
      }).then((response) => {
        console.log(response.data, "xxx");
        self.datos_.push(response.data);
      });
    },
    agregarProducto() {
      let self = this;
      if (!self.current.tienda) {
        Notifications.alert.error(
          "Agregar producto",
          "El campo de tienda es obligatorio"
        );
        return;
      }
      if (self.current.precio_1 == null) {
        return;
      }
      if (self.datos.length > 5) {
        // El array tiene más de 5 objetos, realizar una acción en consecuencia
        Notifications.alert.error(
          "Agregar producto",
          "solo se pueden agregar un maximo de 6 productos"
        );
        return;
      }
      if (self.tienda_id == null) {
        self.tienda_id = self.current.tienda;
      }

      if (self.tienda_id != self.current.tienda) {
        Notifications.alert.error("Agregar producto", "Debe seleccionar la misma tienda");
        return;
      }
      self.precios_imprimir.push(Object.assign({}, self.current));
      self.current = Object.assign(self.current, {
        producto: {
          sku: null,
        },
        errors: {},
        precios_lista: [],
        precio_1: null,
        precio_2: null,
        texto: null,
      });
      // self.functionAgregar();
    },
    functionAgregar() {
      let self = this;
      let nextIndex = self.datos.length + 1;
      let producto = {};
      producto[`p${nextIndex}`] = self.current.producto.sku;
      self.datos.push(producto);
      self.refreshDatos(self.current.producto.sku);
    },
    Imprimir() {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      var reportName = "catalogos/promociones/oferta_colorx6.jrxml&";

      let paramsObject = {
        tienda: self.tienda_id,
        id1: "",
        id2: "",
        id3: "",
        id4: "",
        id5: "",
        id6: "",
        id7: "",
        id8: "",
        id9: "",
        id10: "",
        id11: "",
        id12: "",
        ot1: "",
        ot2: "",
        ot3: "",
        ot4: "",
        ot5: "",
        ot6: "",
        p1: "",
        p2: "",
        p3: "",
        p4: "",
        p5: "",
        p6: "",
        tipo: "",
        txt1: "",
        txt2: "",
        txt3: "",
        txt4: "",
        txt5: "",
        txt6: "",
      };

      let index_global = 0;
      self.precios_imprimir.forEach((element, index) => {
        index_global++;
        var _id = element.precio_1.id + "";
        _id = _id.replace(/-/g, "");
        paramsObject["id" + index_global] = _id;
        paramsObject["ot" + (index + 1)] = "B";
        paramsObject["txt" + (index + 1)] = element.texto;

        index_global++;
        if (element.precio_2 != null && element.precio_2 != "") {
          _id = element.precio_2.id + "";
          _id = _id.replace(/-/g, "");
          paramsObject["id" + index_global] = _id;
        } else {
          paramsObject["id" + index_global] = "";
        }
      });

      var query_params = Object.keys(paramsObject)
        .filter(function (key) {
          return paramsObject[key] ? true : false;
        })
        .map(function (key) {
          return encodeURIComponent(key) + "=" + encodeURIComponent(paramsObject[key]);
        })
        .join("&");
      var url = baseApiUrl + "/cat/reporte/?report_name=" + reportName + query_params;
      window.open(url);
    },
    refreshDataDefault() {
      let self = this;
      self.datos = [];
      self.datos_ = [];
      self.precios_imprimir = [];
      self.tienda_id = null;
      self.current.tienda = "";
      self.current.producto = "";
    },
    seleccionProducto(producto) {
      let self = this;
      DynamicService.getByIdParams("cat", "productos", producto.sku, {
        tienda: self.current.tienda,
        sku: producto.sku,
      }).then((response) => {
        console.log(response.data);
        self.current.precios_lista = response.data.lista_precios;

        self.current.precio_1 =
          self.current.precios_lista[self.current.precios_lista.length - 1];
        self.current.precio_2 = self.current.precios_lista[0];
      });
    },
    quitarItem(current_preview) {
      let self = this;
      let idxObj = self.precios_imprimir.findIndex((object) => {
        return (
          object.precio_1.id == current_preview.precio_1.id &&
          object.precio_2.id == current_preview.precio_2.id
        );
      });

      self.precios_imprimir.splice(idxObj, 1);
    },
    onChangePrecio1(event) {
      alert("");
    },
  },
};
</script>
